import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PlanningGuideHero() {
  return <section id="remodelingplanningguidehero" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-12 pb-16 md:pt-16 md:pb-24 lg:pt-20 lg:pb-28">
      {/* Decorative ambient glass planes */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 right-1/4 h-96 w-96 rounded-full bg-chart-1/10 blur-3xl" />
        <div className="absolute top-1/3 -left-20 h-80 w-80 rounded-full bg-chart-2/5 blur-2xl" />
        <div className="absolute -bottom-10 right-10 h-72 w-72 rounded-full bg-chart-3/15 blur-2xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {/* Layered Glass Content Container */}
        <div className="relative rounded-2xl border border-border/80 bg-card/60 p-6 sm:p-10 md:p-14 shadow-lg backdrop-blur-md">
          {/* Subtle Accent Glow Bar */}
          <div aria-hidden="true" className="absolute top-0 left-10 h-1 w-24 rounded-full bg-chart-1" />

          {/* Breadcrumbs Navigation */}
          <div className="mb-6 md:mb-8">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/">Home</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground">Resources</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Remodeling Planning Guide</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* Header Content */}
          <div className="max-w-3xl">
            <h1 className="font-serif text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl lg:text-6xl">
              Decatur Remodeling Planning Guide
            </h1>
            <p className="mt-5 text-base leading-relaxed text-muted-foreground sm:text-lg md:text-xl">
              A comprehensive roadmap for homeowners in Decatur and neighboring communities to navigate budgeting, design choices, permitting, and timelines for a smooth home renovation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}